import styled from "styled-components";
export const Container = styled.div`
  width: 100%;
  height: 3.56rem;

  padding: 0.25rem 0;

  background: linear-gradient(
    91.27deg,
    rgba(22, 115, 105, 1) 46.08%,
    rgba(22, 115, 105, 0.9) 64.09%
  );
`;

export const Content = styled.div`
  width: 100%;
  margin: 0 auto;
  max-width: ${({ theme }) => theme.grid.container};

  display: flex;
  align-items: center;

  img {
    height: 2.875rem;
    width: 9.375rem;
  }
`;
